export default __webpack_public_path__ + "static/media/books-23.512d4fde.jpg";